import React, { useState, useEffect } from "react";
import "./UserDashboard.css";
import Cookies from "js-cookie";
import axios from 'axios';
import { Redirect } from "react-router-dom";
import { Tooltip, Alert, Button, message, Modal, Avatar, Select, Space, Empty, Spin } from "antd";
import { RightOutlined, LeftOutlined, CheckCircleOutlined, QuestionCircleOutlined, UserAddOutlined, PlusSquareOutlined, DeleteOutlined } from "@ant-design/icons";

const AdminDashboard = () => {

    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");

    const [leftArrow, showLeftArrow] = useState(null);
    const setRightArrowDiv = (index) => {
        showLeftArrow(index)
    }
    const setLeftArrowDiv = (index) => {
        showLeftArrow(null)
    }

    const [leftArrow1, showLeftArrow1] = useState(null);
    const setRightArrowDiv1 = (index) => {
        showLeftArrow1(index)
    }
    const setLeftArrowDiv1 = (index) => {
        showLeftArrow1(null)
    }

    const [leftArrow2, showLeftArrow2] = useState(null);
    const setRightArrowDiv2 = (index) => {
        showLeftArrow2(index)
    }
    const setLeftArrowDiv2 = (index) => {
        showLeftArrow2(null)
    }

    const [leftArrow3, showLeftArrow3] = useState(null);
    const setRightArrowDiv3 = (index) => {
        showLeftArrow3(index)
    }
    const setLeftArrowDiv3 = (index) => {
        showLeftArrow3(null)
    }

    const firstLetters = userLogin
        .split('@')[0]
        .split('.')
        .map(part => part[0])
        .join('').toUpperCase();

    const [currentDate, setCurrentDate] = useState(new Date());

    const getWeekDays = () => {
        const weekdays = [];
        const startDate = new Date(currentDate);
        startDate.setDate(startDate.getDate() - startDate.getDay() + 1);
        for (let i = 0; i < 7; i++) {
            const day = new Date(startDate);
            day.setDate(startDate.getDate() + i);
            weekdays.push(day);
        }
        return weekdays;
    };

    const handlePreviousDay = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - 7);
        setCurrentDate(newDate);
    };

    const handleNextDay = () => {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + 7);
        setCurrentDate(newDate);
    };
    var options = { weekday: 'short' };
    var prnDt = new Date().toLocaleDateString('en-US', options);
    const [selectedDate, setSelectedDate] = useState(prnDt);

    const handleDateClick = (day) => {
        setSelectedDate(day);
    }
    const weekdays = getWeekDays();

    const [usertasks, getUsertasks] = useState([]);
    const [tasks, gettasks] = useState([]);
    const [alerts, getAlerts] = useState([]);
    const [userODtasks, getODtasks] = useState([]);
    const [taskid, setTaskId] = useState([]);
    const [users, getUsers] = useState([]);
    const [user, setUser] = useState();
    const [gruops, getGroups] = useState([]);
    const [tasknames, getTasknames] = useState([]);
    const [assignes, getAssignes] = useState([]);
    const [taskname, setTaskname] = useState([]);
    const [groupname, setGroupname] = useState([]);
    const [username, setUsername] = useState([]);
    const [Dueday, SetDueday] = useState([]);

    const [taskLoading, setTaskLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingDel, setLoadingDel] = useState(false);
    const [openTask, setopenTask] = useState(false);
    const [openTaskLoading, setopenTaskLoading] = useState(false);
    const [opencreatetask, setCreatetask] = useState(false);
    const [openReassign, setopenReassign] = useState(false)
    const [openDel, setopenDel] = useState(false)
    const [error, setError] = useState('');

    const taskDetails = () => {
        setopenTaskLoading(true)
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/CalculateOverDue?uname=` +
                userLogin + `&day=` + selectedDate,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => {
                getUsertasks(resp.data)
                setopenTaskLoading(false)
            })

    };

    useEffect(() => {
        taskDetails();
    }, [userLogin, selectedDate]);

    const alertList = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/Alerts?uname=` +
                userLogin,
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getAlerts(resp.data))
    };
    useEffect(() => {
        alertList();
    }, [userLogin]);

    const userList = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetUserUnderManagers?uname=` +
                userLogin,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getUsers(resp.data))
    };
    useEffect(() => {
        userList();
    }, []);

    const assigneList = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetAllUserID's`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getAssignes(resp.data))
    };

    useEffect(() => {
        assigneList();
    }, []);

    const taskDetailsOfUsers = () => {
        // const temp = prop;
        setTaskLoading(true)
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/CalculateOverDue?uname=` +
                user + `&day=` + selectedDate,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => {
                gettasks(resp.data)
                setTaskLoading(false)
            })

    };

    const [count, setCount] = useState(0);
    useEffect(() => {
        taskDetailsOfUsers();
    }, [count, user, selectedDate])

    const ODtaskDetailsOfUsers = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/Alerts?uname=` +
                user,
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getODtasks(resp.data))
    };
    useEffect(() => {
        ODtaskDetailsOfUsers();
    }, [count, user]);

    const getTaskId = (item) => {
        setTaskId(item)
    }

    const handleStatusUpdate = async () => {

        const url = `${process.env.REACT_APP_BASE_URL}UserTask/updatestatus?taskid=` + taskid + `&status=Completed&uname=` + userLogin;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            const res = await axios.post(url, config)
            message.success(`Updated your task status successfully.`);
            // setCount(count + 1)
        }
        catch (error) {
            message.error('Task status is not Updated, Try again..');
        }
        taskDetails();
        alertList();
    };
    const handleReassign = async () => {

        const url = `${process.env.REACT_APP_BASE_URL}UserTask/ReassaignTask?tasksid=` + taskid + `&assagneeid=` + username
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            setLoading(true);
            const res =
                await axios.post(url, config)
                    .then((response) => {
                        setLoading(true);
                        setLoading(false);
                        message.success(`Assigned successfully.`);
                        setopenReassign(false);
                        setUsername([])
                    })
        }
        catch (error) {
            message.error('Error, Try again..');
            setopenReassign(false)
            setUsername([])
        }
        taskDetailsOfUsers();
        ODtaskDetailsOfUsers();
        taskDetails();
        alertList();
        userList();
    };
    
    const handleDelete = async () => {
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/RemoveUsertask?taskid=` + taskid
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            setLoadingDel(true)
            const res = await axios.delete(url, config)
            if (res.data.statusCode === 200) {
                message.success('Deleted successfully!');
                setLoadingDel(false)
                setopenDel(false)
                setTaskId([])
            }
            else if (response.data.statusCode === 500) {
                message.warning(response.data.message)
                setLoadingDel(false)
                setopenDel(false)
                setTaskId([])
            }
            else {
                setLoadingDel(false)
                setopenDel(false)
                setTaskId([])
            }

        }
        catch (error) {
            message.error('Error, Try again..');
            setopenDel(false)
            setLoadingDel(false)
            setTaskId([])
        }
        finally {
            setLoadingDel(false)
            taskDetailsOfUsers();
            ODtaskDetailsOfUsers();
            taskDetails();
            alertList();
            userList();
        }
    };

    const getGroupnames = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetGroups`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getGroups(resp.data))
    };
    useEffect(() => {
        getGroupnames();
    }, []);

    const encodedGroupname = encodeURIComponent(groupname);
    const encodedTaskname = encodeURIComponent(taskname);
    const gettasknames = () => {
        setTaskname([])
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}UserTask/GetTasksBasedonGroup?groupname=` + encodedGroupname,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => getTasknames(resp.data))
    };
    useEffect(() => {
        gettasknames();
    }, [encodedGroupname]);

    const handleGroupname = (e) => {
        setGroupname(e.target.value);
    }

    const handleTaskname = (e) => {
        setTaskname(e.target.value);
    }

    const handleUser = (item) => {
        setUser(item);
        showModalForTasks();
    }
    const handleDueday = (e) => {
        SetDueday(e.target.value);
    }

    const Days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    const handleCreateTask = async () => {
        if (groupname.length === 0 || taskname.length === 0 || username.length === 0 || Dueday.length === 0) {
            setError('Please select all fields');
            return;
        }
        const url = `${process.env.REACT_APP_BASE_URL}UserTask/CreateTask?uname=`
            + userLogin + `&task=` + encodedTaskname + `&assaignuser=` + username + `&groupname=` + encodedGroupname + `&inputday=` + Dueday;
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        try {
            setLoading(true);
            const res =
                await
                    axios.post(url, config)
                        .then((response) => {
                            message.success(`Created successfully.`);
                            setCreatetask(false);
                            setGroupname([])
                            setTaskname([])
                            setUsername([])
                            SetDueday([])
                            getTasknames([])
                            setError('');
                            setLoading(false);
                        })
        }
        catch (error) {
            message.error("Try again...")
            setLoading(false);
            setCreatetask(false);
            setGroupname([])
            setTaskname([])
            setUsername([])
            SetDueday([])
        }
        finally {
            userList();
            taskDetails();
            alertList();
            taskDetailsOfUsers();
            ODtaskDetailsOfUsers();
        }
    };

    const showModalForTasks = () => {
        setopenTask(true);
    };
    const handleOk = () => {
        setopenTask(false);
    };
    const handleCancelforTask = () => {
        setopenTask(false);
    }
    const showModalCreateTask = () => {
        setCreatetask(true);
    };
    const handleCancelforCreateTask = () => {
        setGroupname([])
        setTaskname([])
        setUsername([])
        SetDueday([])
        getTasknames([])
        setCreatetask(false);
        setError('')
    }

    const showModalForReassign = () => {
        setopenReassign(true);
    };

    const handleCancelReassign = () => {
        setUsername([])
        setopenReassign(false);
    };
    const showModalForDelete = () => {
        setopenDel(true);
    };
    const handleCancelDelete = () => {
        setTaskId([])
        setopenDel(false);
    };

    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }

    return (
        <>
            <div className="usertasks">
                <div className="alerts-view">
                    {
                        alerts ? alerts.map((item, index) => {
                            return (
                                <Alert message={item.taskName} className="task-alert" type="warning" showIcon closable />
                            )
                        }) : null
                    }
                </div>
                <div className="calendar-view">
                    <div className="calendar-div">
                        <input onClick={handlePreviousDay} value="<" type="button"
                            className="move" />
                        <div className="inside-calender">
                            {
                                weekdays.map((day, index) => (
                                    <Tooltip placement="top" title={day.getDate() + ", " + (day.toLocaleString('en-US', { month: 'long' }))} color={'#002766'}>
                                        <div key={index} className={day.toDateString() === new Date().toDateString() ? 'highlight' : 'day-name'} onClick={() => handleDateClick(day.toLocaleDateString('en-US', { weekday: 'short' }))}>
                                            <p style={{ textAlign: "center", marginLeft: "10%" }}>{day.toLocaleDateString('en-US', { weekday: 'short' })}</p>
                                            <p style={{ textAlign: "center", marginTop: "13px" }}>{day.getDate()}</p>
                                        </div>
                                    </Tooltip>
                                ))
                            }
                        </div>
                        <input onClick={handleNextDay} value=">" type="button"
                            className="move" />
                    </div>
                </div>
                <div className="usertasks-display">
                    <div className="users-list">
                        <div className="users-div">
                            {
                                users ? users.map((item, index) => {
                                    const first = item.split('@')[0]
                                        .split('.')
                                        .map(part => part[0])
                                        .join('').toUpperCase();

                                    return (<div className="user-card">
                                        <Tooltip color={'#002766'} key={index} title={item} onClick={(e) => handleUser(item)}>
                                            <Avatar
                                                style={{
                                                    backgroundColor: '#002766',
                                                }}
                                                size={{
                                                    sm: 30,
                                                }}
                                            >{first}
                                            </Avatar>
                                        </Tooltip>
                                    </div>)
                                }) : null
                            }
                            <Modal
                                open={openTask}
                                onOk={handleOk}
                                onCancel={handleCancelforTask}
                                width={700}
                                footer={[
                                    <Button style={{ backgroundColor: "#002766" }} key="submit" type="primary" loading={loading} onClick={handleOk}>
                                        Ok
                                    </Button>,
                                ]}
                            >
                                {
                                    taskLoading ? <div className="example">
                                        <Spin />
                                    </div> :
                                        <div className="render-tasks">
                                            <div>
                                                {
                                                    tasks.length !== 0 ?
                                                        <div >{
                                                            tasks.map((item, index) => {
                                                                const email = item.assignedTo_User_Id.split('@')[0]
                                                                    .split('.')
                                                                    .map(part => part[0])
                                                                    .join('').toUpperCase();
                                                                return (
                                                                    <div className="tasklist-class">
                                                                        <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                                            <div className="avatar-div">
                                                                                <Tooltip color={'#002766'} key={index} title={item.assignedTo_User_Id}>
                                                                                    <Avatar
                                                                                        style={{
                                                                                            backgroundColor: '#002766',
                                                                                            cursor: "pointer"
                                                                                        }}
                                                                                        size={{
                                                                                            sm: 32,
                                                                                        }}
                                                                                    >
                                                                                        {email}
                                                                                    </Avatar>
                                                                                </Tooltip>
                                                                            </div>
                                                                            <div className="name-arrow-class">
                                                                                <div className="taskname-class">
                                                                                    <div className="task-name">
                                                                                        {item.taskName}
                                                                                    </div>
                                                                                    <div className="today-date">
                                                                                        {item.task_Status}
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    leftArrow2 === index ?
                                                                                        <div className="arrow-icon-div">
                                                                                            <Tooltip color={'#002766'} title="Delete task"><DeleteOutlined className="del-icon" onClick={showModalForDelete} /></Tooltip>
                                                                                            <Modal
                                                                                                open={openDel}
                                                                                                onCancel={handleCancelDelete}
                                                                                                onOk={handleDelete}
                                                                                                okText="Yes"
                                                                                                confirmLoading={loadingDel}
                                                                                                cancelText="No"
                                                                                            >
                                                                                                <p>Are you sure delete this task?</p>
                                                                                            </Modal>
                                                                                            <Tooltip color={'#002766'} title="Reassign task"><UserAddOutlined className="status-icon" onClick={showModalForReassign} /></Tooltip>
                                                                                            <Modal
                                                                                                open={openReassign}
                                                                                                onCancel={handleCancelReassign}
                                                                                                footer={[
                                                                                                    <Button style={{ backgroundColor: "#002766" }} key="submit" type="primary" loading={loading} onClick={handleReassign} >
                                                                                                        Submit
                                                                                                    </Button>,
                                                                                                ]}
                                                                                            >
                                                                                                <label style={{ marginRight: 10, fontWeight: 600, color: "#002766" }}>Assign To:  </label>
                                                                                                <Select
                                                                                                    // size="x large"
                                                                                                    placeholder="Select User"
                                                                                                    width={300}
                                                                                                    value={username}
                                                                                                    onChange={(newUser) => {
                                                                                                        setUsername(newUser);
                                                                                                    }}
                                                                                                >
                                                                                                    {assignes.map((items, index) => {
                                                                                                        return (
                                                                                                            <Select.Option key={index} value={items} width={300} >
                                                                                                                {items}
                                                                                                            </Select.Option>
                                                                                                        );
                                                                                                    })}
                                                                                                </Select>
                                                                                            </Modal>
                                                                                            <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv2(index)} />
                                                                                        </div>
                                                                                        : <div className="arrow-icon">
                                                                                            <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv2(index)} />
                                                                                        </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                        : <div>
                                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                                className="notask-heading"
                                                                description={
                                                                    <span>
                                                                        No tasks for the day
                                                                    </span>
                                                                }
                                                            >
                                                            </Empty>
                                                            {/* <h1 className="notask-heading">No tasks for the day</h1> */}
                                                        </div>
                                                }
                                            </div>
                                            <div>
                                                {
                                                    userODtasks.length !== 0 ?
                                                        <div >{
                                                            userODtasks.map((item, index) => {
                                                                const email = item.assignedTo_User_Id.split('@')[0]
                                                                    .split('.')
                                                                    .map(part => part[0])
                                                                    .join('').toUpperCase();
                                                                return (
                                                                    <div className="tasklist-class">
                                                                        <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                                            <div className="avatar-div">
                                                                                <Tooltip color={'#002766'} key={index} title={item.assignedTo_User_Id}>
                                                                                    <Avatar
                                                                                        style={{
                                                                                            backgroundColor: '#002766',
                                                                                            cursor: "pointer"
                                                                                        }}
                                                                                        size={{
                                                                                            sm: 32,
                                                                                        }}
                                                                                    >
                                                                                        {email}
                                                                                    </Avatar>
                                                                                </Tooltip>
                                                                            </div>
                                                                            <div className="name-arrow-class">
                                                                                <div className="taskname-class">
                                                                                    <div className="task-name">
                                                                                        {item.taskName}
                                                                                    </div>
                                                                                    <div className="today-date" style={{ color: "red" }}>
                                                                                        Overdue
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    leftArrow3 === index ?
                                                                                        <div className="arrow-icon-div">
                                                                                            <Tooltip color={'#002766'} title="Delete task"><DeleteOutlined className="del-icon" onClick={showModalForDelete} /></Tooltip>
                                                                                            <Modal
                                                                                                open={openDel}
                                                                                                onCancel={handleCancelDelete}
                                                                                                onOk={handleDelete}
                                                                                                okText="Yes"
                                                                                                cancelText="No"
                                                                                                confirmLoading={loadingDel}
                                                                                            >
                                                                                                <p>Are you sure delete this task?</p>
                                                                                            </Modal>
                                                                                            <Tooltip color={'#002766'} title="Reassign task"><UserAddOutlined className="status-icon" onClick={showModalForReassign} /></Tooltip>
                                                                                            <Modal
                                                                                                open={openReassign}
                                                                                                onCancel={handleCancelReassign}
                                                                                                footer={[
                                                                                                    <Button style={{ backgroundColor: "#002766" }} key="submit" type="primary" loading={loading} onClick={handleReassign} >
                                                                                                        Submit
                                                                                                    </Button>,
                                                                                                ]}
                                                                                            >
                                                                                                <label style={{ marginRight: 10, fontWeight: 600, color: "#002766" }}>Assign To:  </label>
                                                                                                <Select
                                                                                                    size="x large"
                                                                                                    placeholder="Select User"
                                                                                                    value={username}
                                                                                                    onChange={(newUser) => {
                                                                                                        setUsername(newUser);
                                                                                                    }}
                                                                                                >
                                                                                                    {assignes.map((items, index) => {
                                                                                                        return (
                                                                                                            <Select.Option key={index} value={items} >
                                                                                                                {items}
                                                                                                            </Select.Option>
                                                                                                        );
                                                                                                    })}
                                                                                                </Select>
                                                                                            </Modal>
                                                                                            <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv3(index)} />
                                                                                        </div>
                                                                                        : <div className="arrow-icon">
                                                                                            <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv3(index)} />
                                                                                        </div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                        : <div >
                                                            {/* <h1 className="notask-heading" style={{ marginLeft: "44%" }}>No tasks</h1> */}
                                                        </div>
                                                }
                                            </div>
                                        </div>}
                            </Modal>
                        </div>
                        <div className="create-task-view">
                            <Tooltip color={'#002766'} title="Add task">
                                <h1 className="create-task" onClick={showModalCreateTask}><PlusSquareOutlined />Create</h1>
                            </Tooltip>
                            <Modal
                                open={opencreatetask}
                                // onOk={handleClick}
                                onCancel={handleCancelforCreateTask}
                                footer={[
                                    <Button style={{ backgroundColor: "#002766" }} key="submit" type="primary" loading={loading} onClick={handleCreateTask}>
                                        Create
                                    </Button>,
                                ]}
                            >
                                <Space wrap>
                                    <Select
                                        size="x large"
                                        placeholder="Select Group"
                                        style={{ width: 150 }}
                                        value={groupname}
                                        options={gruops.map((group) => ({
                                            label: group,
                                            value: group,
                                        }))}
                                        onChange={(newGroup) => {
                                            setGroupname(newGroup)
                                        }}
                                    />
                                    <Select
                                        size="x large"
                                        placeholder="Select Task"
                                        style={{ width: 150 }}
                                        value={taskname}
                                        options={tasknames.map((task) => ({
                                            label: task,
                                            value: task,
                                        }))}
                                        onChange={(newTask) => {
                                            setTaskname(newTask)
                                        }}
                                    />
                                </Space>
                                <br />
                                <br />
                                <label style={{ marginRight: 10, fontWeight: 600, color: "#002766" }}>Assign To:  </label>
                                <Select
                                    size="x large"
                                    placeholder="Select User"
                                    style={{ width: 150 }}
                                    value={username}
                                    options={assignes.map((assign) => ({
                                        label: assign,
                                        value: assign,
                                    }))}
                                    onChange={(newUser) => {
                                        setUsername(newUser);
                                    }}
                                />
                                <br />
                                <br />
                                <label style={{ marginRight: 10, fontWeight: 600, color: "#002766" }}>Task Due Day:  </label>
                                <Select
                                    mode="multiple"
                                    size="x large"
                                    style={{ width: 150 }}
                                    value={Dueday}
                                    placeholder="Select Dueday"
                                    allowClear
                                    maxTagCount="responsive"
                                    options={Days.map((Week) => ({
                                        label: Week,
                                        value: Week,
                                    }))}
                                    onChange={(newDay) => {
                                        SetDueday(newDay);
                                    }}
                                />
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                            </Modal>
                        </div>
                    </div>

                    {openTaskLoading ? <div className="render-tasks">
                        <div className="example">
                            <Spin size="large" />
                        </div>
                    </div>
                        : <div className="render-tasks">
                            <div>
                                {
                                    usertasks.length !== 0 ?
                                        <div >{
                                            usertasks.map((item, index) => {
                                                return (
                                                    <div className="tasklist-class">

                                                        <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                            <div className="avatar-div">
                                                                <Avatar
                                                                    style={{
                                                                        backgroundColor: '#002766',
                                                                    }}
                                                                >
                                                                    {firstLetters}
                                                                </Avatar>
                                                            </div>
                                                            <div className="name-arrow-class">
                                                                <div className="taskname-class">
                                                                    <div className="task-name">
                                                                        {item.taskName}
                                                                    </div>
                                                                    <div className="today-date">
                                                                        {item.task_Status}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    leftArrow === index ?
                                                                        <div className="arrow-icon-div">
                                                                            <Tooltip color={'#002766'} title="Delete task"><DeleteOutlined className="del-icon" onClick={showModalForDelete} /></Tooltip>
                                                                            <Modal
                                                                                open={openDel}
                                                                                onCancel={handleCancelDelete}
                                                                                onOk={handleDelete}
                                                                                okText="Yes"
                                                                                cancelText="No"
                                                                                confirmLoading={loadingDel}
                                                                            >
                                                                                <p>Are you sure delete this task?</p>
                                                                            </Modal>
                                                                            <Tooltip color={'#002766'} title="Click here to mark as completed"> <CheckCircleOutlined className="status-icon" onClick={handleStatusUpdate} /></Tooltip>
                                                                            <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv(index)} />
                                                                        </div>
                                                                        : <div className="arrow-icon">
                                                                            <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv(index)} />
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        : <div>
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                className="notask-heading"
                                                description={
                                                    <span>
                                                        No tasks for the day
                                                    </span>
                                                }
                                            >
                                            </Empty>
                                            {/* <h1 className="notask-heading">No tasks for the day</h1> */}
                                        </div>
                                }
                            </div>
                            <div className="overdue-tasks">
                                {
                                    alerts.length !== 0 ?
                                        <div >{
                                            alerts.map((item, index) => {
                                                return (
                                                    <div className="tasklist-class">
                                                        <div className="inside-tasks" onClick={() => getTaskId(item.taskId)}>
                                                            <div className="avatar-div">
                                                                <Avatar
                                                                    style={{
                                                                        backgroundColor: '#002766',
                                                                    }}
                                                                >
                                                                    {firstLetters}
                                                                </Avatar>
                                                            </div>
                                                            <div className="name-arrow-class">
                                                                <div className="taskname-class">
                                                                    <div className="task-name">
                                                                        {item.taskName}
                                                                    </div>
                                                                    <div className="today-date" style={{ color: "red" }}>
                                                                        Overdue since {item.task_Due_Date}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    leftArrow1 === index ?
                                                                        <div className="arrow-icon-div">
                                                                            <Tooltip color={'#002766'} title="Delete task"><DeleteOutlined className="del-icon" onClick={showModalForDelete} /></Tooltip>
                                                                            <Modal
                                                                                open={openDel}
                                                                                onCancel={handleCancelDelete}
                                                                                onOk={handleDelete}
                                                                                okText="Yes"
                                                                                cancelText="No"
                                                                                confirmLoading={loadingDel}
                                                                            >
                                                                                <p>Are you sure delete this task?</p>
                                                                            </Modal>
                                                                            <Tooltip color={'#002766'} title="Click here to mark as completed"><CheckCircleOutlined className="status-icon" onClick={handleStatusUpdate} /></Tooltip>
                                                                            <LeftOutlined className="navigation-leftarrow" onClick={(e) => setLeftArrowDiv1(index)} />
                                                                        </div>
                                                                        : <div className="arrow-icon">
                                                                            <RightOutlined className="navigation-rightarrow" onClick={(e) => setRightArrowDiv1(index)} />
                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        : <div>
                                            {/* <h1 className="notask-heading" style={{ marginLeft: "45%" }}>No tasks</h1> */}
                                        </div>
                                }
                            </div>
                        </div>}
                </div>
            </div>
        </>

    );
}
export default AdminDashboard;